export const SET_EXEC_YEARMONTH = "SET_EXEC_YEARMONTH";

export interface ExecYearmonthState {
  exec_yearmonth: string;
  error: boolean;
}
